import { createContext } from "react";
import type { BrandThemeContextValue } from "@/features/theme/types/brandTheme.type";

export const BrandThemeContext = createContext<BrandThemeContextValue | null>(null);

BrandThemeContext.displayName = "BrandThemeContext";
